import { Fragment } from "react/jsx-runtime";
import SignUp from "../components/SignUp/SignUp";
import AuthNavbar from "../components/common/AuthNavbar";

const Register = () => {
  return (
    <div className="flex flex-col h-screen bg-white">
      <AuthNavbar />

      {/* Main content should take remaining height */}
      <div className="flex-1 overflow-auto bg-secondary ">
        <SignUp />
      </div>
    </div>
  );
};

export default Register;